/**
 * Route for `row-actions-menu-edit-pause-duplicate-delete`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RowActionsMenuEditPauseDuplicateDeletePage } from "../features/row-actions-menu-edit-pause-duplicate-delete/RowActionsMenuEditPauseDuplicateDeletePage";

export const rowActionsMenuEditPauseDuplicateDeleteRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/row-actions-menu-edit-pause-duplicate-delete",
	component: RowActionsMenuEditPauseDuplicateDeletePage,
});

export default rowActionsMenuEditPauseDuplicateDeleteRoute;
